<template>
  <div class="quote flex" v-if="Object.keys(quoteMsg).length > 0">
    <div style="width: calc(100% - 20px);">
      <div v-html="quoteMsgTxt" class="ellipsis-2-lines"></div>
    </div>
    <el-icon @click="handleQuoteClose" style="cursor: pointer;"><Close /></el-icon>
  </div>
</template>

<script setup name="ChatInputQuote">
import { defineProps, defineEmits, computed } from 'vue'
const props = defineProps({
  quoteMsg: {
    type: Object,
    default: () => { }
  },
  custInfo: {
    type: Object,
    default: () => { }
  },
  agentInfo: {
    type: Object,
    default: () => { }
  }
})

const quoteMsgTxt = computed(() => {
  let name = ''
  if (props.quoteMsg?.value === 3) { 
    name = props.quoteMsg.fromName || props.custInfo.custName
  }
  if (props.quoteMsg?.value === 2) {
    if (props.quoteMsg.isAi && props.quoteMsg.isAi == 1) {
      name = '在线机器人'
    }
  }
  if (props.quoteMsg.type === 1) {
    return `${name}:  ${props.quoteMsg.text}`
  } else if(props.quoteMsg.type === 20){
    return `${name || props.quoteMsg.fromName}:  ${props.quoteMsg.text}`
  } else { 
    let msgTypeStr = ''
    let obj = {
      2: '语音',
      3: '图片',
      4: '文件',
      5: '链接',
      6: '视频',
      11: '留言'
    }
    if (props.quoteMsg?.type) { 
      msgTypeStr = ` [${obj[props.quoteMsg.type]}] `
    }
    return `${name}: ${msgTypeStr}`
  }
})

const emit = defineEmits(['close'])


const handleQuoteClose = () => {
  emit('close')
}

</script>

<style lang="less" scoped>
.quote {
  background: #e9e9e9;
  padding: 8px 10px;
  font-size: 12px;
  color: #777777;
  border-radius: 4px;
  margin: 5px;
  :deep(*) {
    display: block;
    padding: 0;
    margin: 0;
    line-height: 21px;
  }
}
.ellipsis-2-lines {
  /* 设置容器宽度（根据需求调整） */
  width: 100%;
  /* 启用弹性盒子布局（旧版语法，用于兼容） */
  display: -webkit-box;
  /* 设置文本方向为垂直排列 */
  -webkit-box-orient: vertical;
  /* 限制显示两行 */
  -webkit-line-clamp: 2;
  /* 隐藏溢出内容 */
  overflow: hidden;
  /* 省略号样式 */
  text-overflow: ellipsis;
  /* 可选：设置行高，确保高度计算准确 */
  line-height: 1.5em;
  /* 可选：根据行高计算最大高度（2行 × 行高） */
  max-height: 3em;
  /* 兼容其他浏览器（如 Firefox） */
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-line-clamp: 2;
}
</style>
